import {
  ROUTE_USER_MODULES_JOIN,
  ROUTE_USER_MODULES_MY,
  ROUTE_EXPERT_PROVIDER_MODULES_LIBRARY,
  ROUTE_EXPERT_PROVIDER_MODULES_MY,
  ROUTE_EXPERT_PROVIDER_MODULES_OTHER,
  ROUTE_EXPERT_PROVIDER_MODULES_TEMPLATES,
} from "Consts/publicRoutes";

export const SIDENAV_MODULES_SECTION = {
  text: "Modules",
  userRoute: ROUTE_USER_MODULES_MY,
  restrictedRoute: ROUTE_EXPERT_PROVIDER_MODULES_LIBRARY,
  templateRoute: ROUTE_EXPERT_PROVIDER_MODULES_TEMPLATES,
};

export const SIDENAV_MODULES_COACH_PROVIDER_MODULES_ROUTE = {
  text: "Main library",
  route: {
    name: ROUTE_EXPERT_PROVIDER_MODULES_LIBRARY,
    params: { tab: "main library" },
  },
};

export const SIDENAV_MODULES_COACH_PROVIDER_OTHER_ROUTE = {
  text: "Created by others",
  route: {
    name: ROUTE_EXPERT_PROVIDER_MODULES_OTHER,
    params: { tab: "created by others" },
  },
};

export const SIDENAV_MODULES_COACH_PROVIDER_MY_ROUTE = {
  text: "Created by me",
  route: {
    name: ROUTE_EXPERT_PROVIDER_MODULES_MY,
    params: { tab: "created by me" },
  },
};

export const SIDENAV_MODULES_ARCHIVED_ROUTE = {
  text: "Archive",
  route: { name: "archive" },
};

export const SIDENAV_CLIENT_MODULES_ROUTE = {
  text: "My modules",
  route: { name: ROUTE_USER_MODULES_MY },
};

export const SIDENAV_MODULES_CLIENT_JOIN_ROUTE = {
  text: "Join",
  route: { name: ROUTE_USER_MODULES_JOIN },
};

export const SIDENAV_MODULES_PROVIDER_TEMPLATE_ROUTE = {
  text: "Templates",
  route: {
    name: ROUTE_EXPERT_PROVIDER_MODULES_TEMPLATES,
    params: { tab: "templates" },
  },
};
